import { PaymentProcessorEnum } from '@systemeio/ui'
import { PaymentIntegrationsType } from 'modules/profile/payment-gateways/types/connected-payment-integrations-interface'

export function isDesiredIntegration<T extends PaymentIntegrationsType>(
  integration: PaymentIntegrationsType,
  paymentProcessor: PaymentProcessorEnum,
): integration is T {
  return integration.paymentProcessor === paymentProcessor
}
